var map = {
	"./2021/10-17.json": 975,
	"./2021/10-25.json": 275,
	"./2022/02-13.json": 729,
	"./2022/09-26.json": 903,
	"./2022/11-25.json": 254,
	"./2023/11-08.json": 928,
	"./2024/01-31.json": 379,
	"./2024/05-17.json": 542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 405;